<template>
  <ObTabs
    v-if="navBarDisplay"
    ref="obTabsRef"
    :tabs="tabs"
    :ellipsis="false"
    :shrink="true"
    :titleStyle="{
      fontSize: '16px',
      padding: '0 9px 6px'
    }"
    :lazyRender="false"
    :offset-top="((navigationHeight * 1) + (noticeHeight * 1))"
    sticky
    line-height="2"
    color="var(--color-brandSecondary-community)"
    background="var(--color-background-primary)"
    title-active-color="var(--color-text-primary)"
    title-inactive-color="var(--color-text-description)"
    @switch="onSwitchTab"
  >
    <template #explore>
      <Explore />
    </template>
    <template #myFollowing>
      <MyFollowing />
    </template>
    <template #myCircles>
      <MyCircles :data="circleList"/>
    </template>
    <template #[localName]>
      <ThreadList apiName="getLocalCircle" :options="localOptions"/>
    </template>
    <template 
      v-for="category in circleTabList"
      :key="category.id"
      #[category.name]
    >
      <ThreadList :categoryId="category.id" apiName="getCircleCategoryList"/>
    </template>
  </ObTabs>
  <PostBar />
  <!-- 新人圈子推荐 -->
  <CircleRecommend v-if="!circleList.length"></CircleRecommend>
</template>
<script setup>
import Explore from './components/explore'
import MyCircles from './components/myCircles'
import ThreadList from './components/threadList'
import MyFollowing from './components/myFollowing'
import CircleRecommend from './components/circleRecommend'

import { storeToRefs } from 'pinia'
import { useRoute } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { useSystemStore } from '@/stores/system'
import { useNavigationStore } from '@/stores/navigation'
import { onActivated } from 'vue'

const route = useRoute()
const userStore = useUserStore()  // 用户仓库
const systemStore = useSystemStore()  // 用户仓库
const navigationStore = useNavigationStore()  // 用户仓库
const { uid } = storeToRefs(userStore)   // 用户id
const { homeTab } = storeToRefs(systemStore)   // 用户id
const { navigationHeight, noticeHeight, navBarDisplay } = storeToRefs(navigationStore)   // 用户id
const { proxy } = getCurrentInstance()

const obTabsRef = ref(null)

const localName = ref('')

const circleList = ref([])
const circleTabList = ref([])

const tabs = ref([{
  name: 'explore',
  title: proxy.$t('explore')
}])

const localOptions = ref([{
  label: proxy.$t('recommended'),
  value: 1
},{
  label: proxy.$t('latestCreated'),
  value: 2
},{
  label: proxy.$t('latestActivity'),
  value: 3
}])


function onSwitchTab (val) {
  if (!val) return 
  proxy.$ga('click_top_nav', {
    "nav_name": val
  })
} 

async function getFollowingList () {
  // 获取关注列表
  const { code, data, msg } = await proxy.$http.getFollowingList({ uid: uid.value })
  if (code === 200) {
    const { total } = data || {}
    if (!total) return
    tabs.value.push({
      name: 'myFollowing',
      title: proxy.$t('myFollowing')
    })
  }
}

async function getMyCircles () {
  const { code, data, msg } = await proxy.$http.getMyCircles({
    source: 0
  })
  if (code === 200 && data?.length) {
    circleList.value = data
    if (tabs.value.findIndex(i => i.name === 'myCircles') < 0) {
      tabs.value.push({
        name: 'myCircles',
        title: proxy.$t('myCircles')
      })
    }
  }
}

async function getLocalCircle () {
  const { code, data, msg } = await proxy.$http.getLocalCircle({
    page: 1,
    limit: 1,
    sortType: 2
  })
  if ((code === 200) && data) {
    const { total, rows } = data || {}
    if (!total) return
    localName.value = rows[0].circleInfo.name
    const tab = {
      name: localName.value,
      title: localName.value
    }
    tabs.value.push(tab)
  }
}

async function getCircleCategory () {
  const { code, data, msg } = await proxy.$http.getCircleCategory()
  if ((code === 200) && data) {
    circleTabList.value = data.map(i => {
      return {
        name: i.name,
        title: i.name,
        id: i.id
      }
    })
    tabs.value = [...tabs.value, ...circleTabList.value]
  }
}

function switchToTargetTab (loop) {
  const existTabs = tabs.value.some(i => i.name === 'myFollowing' || i.name === 'myCircles')
  if (homeTab.value && obTabsRef.value && existTabs) {
    if (!homeTab.value) return // 通过 queryHomeTab 进来的时候，homeTab.value 依然可能为空
    obTabsRef.value.active = homeTab.value
    obTabsRef.value.onChangeTab()
    homeTab.value = ''
  } else {
    loop && switchToTargetTab()
  }
}

watch(homeTab, (val) => {
  if (val) {
    switchToTargetTab(true)
  }
}, {
  immediate: true,
  deep: true
})

onActivated(() => {
  if (circleList.value?.length) {
    getMyCircles()
  }
})

onBeforeMount(async () => {
  const { VITE_COUNTRY } = import.meta.env
  if (uid.value) {
    await getFollowingList()
    await getMyCircles()
  }
  if (VITE_COUNTRY === 'PARIS') {
    await getLocalCircle()
  }
  await getCircleCategory()
  switchToTargetTab(false)
})

</script>
<style lang="postcss" scoped>
.ob-tabs {
  :deep(.van-tabs__wrap) {
    --van-tabs-line-height: 42px;
    .van-tabs__nav {
      padding-left: 12px;
    }
  }
}
</style>